import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconVIN: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 40 40" name="vin">
    <path d="M9.166 21.667v-8.333h2v8.333h-2ZM14.083 13.334v8.333h3v-8.333h-3ZM19 21.667v-8.333h2v8.333h-2ZM23.916 13.334v8.333h3v-8.333h-3ZM28.833 21.667v-8.333h2v8.333h-2ZM31 24H9v2h22v-2Z" />
    <path
      fillRule="evenodd"
      d="M7.5 9.167A3.333 3.333 0 0 0 4.165 12.5v15a3.333 3.333 0 0 0 3.333 3.334h25a3.333 3.333 0 0 0 3.334-3.334v-15a3.333 3.333 0 0 0-3.334-3.333h-25Zm25 2h-25c-.737 0-1.334.597-1.334 1.333v15c0 .737.597 1.334 1.333 1.334h25c.737 0 1.334-.597 1.334-1.334v-15c0-.736-.597-1.333-1.334-1.333Z"
      clipRule="evenodd"
    />
  </Icon>
);
